import React, { useEffect, useState } from "react"
import { Box, Typography } from "src/UILibrary"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"
import { Grid } from "src/UILibrary"
import { TableHeaderItem } from "src/components/mypage/TableHeaderItem"
import { UserTableItem } from "../component/UserTableItem"
import { MemberTab } from "../component/MemberTab"
import { MEMBER_TYPE } from "src/modules/const"
import { UserDetail } from "./UserDetail"
import { AdviserDetail } from "./AdviserDetail"
import { CompanyDetail } from "./CompanyDetail"
import { JobDetail } from "./JobDetail"
import { ServiceDetail } from "./ServiceDetail"
import { AdministratorDetail } from "./AdministratorDetail"
import { Admin, Adviser, Company, Member } from "src/openapi"
import { MemoList } from "./MemoList"

type Props = {
  item?: Member | Adviser | Company | Admin
  closeDetail: any
  userType: number
}

const TAB = {
  REGISTERED_INFORMATION: 1,
  JOB_INFORMATION: 2,
  COMPANY_INFORMATION: 3,
  COMPANY_MEMO: 4,
  GENERAL_MEMO: 2,
}

export const MemberDetail = ({ item, closeDetail, userType }: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "mypage.user" })

  const isPC = useMediaQuery({ query: "(min-width: 1400px)" })
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })

  const [tabs, setTabs] = useState<string[]>([])
  const [selectedTab, setSelectedTab] = useState<number>(TAB.REGISTERED_INFORMATION)

  let headers = [
    {
      size: isPC ? 2 : isTablet ? 2 : 1,
      name: t("name"),
      sortby: "name",
    },
    {
      size: isPC ? 2 : isTablet ? 3 : 1,
      name: t("register_area"),
      sortby: "areaId",
    },
    {
      size: isPC ? 6 : isTablet ? 3 : 1,
      name: t("user_type"),
      sortby: "user_type",
    },
    {
      size: isPC ? 2 : isTablet ? 4 : 1,
      name: t("last_login"),
      sortby: "last_login",
    },
  ]

  useEffect(() => {
    if (!item) {
      return
    }

    switch (userType) {
      case MEMBER_TYPE.USER:
      case MEMBER_TYPE.ADVISER:
      case MEMBER_TYPE.ADMINISTRATOR:
        setTabs([t("tab_register_information"), t("tab_register_memo")])
        setSelectedTab(TAB.REGISTERED_INFORMATION)
        break
      case MEMBER_TYPE.COMPANY:
        setTabs([
          t("tab_register_information"),
          t("tab_job_information"),
          t("tab_company_information"),
          t("tab_register_memo"),
        ])
        setSelectedTab(TAB.REGISTERED_INFORMATION)
        break
    }
  }, [item])

  if (!item) {
    return null
  }

  return (
    <Box
      sx={{
        ...(isTablet
          ? { height: "auto", pt: "0px", pl: "20px" }
          : { width: "100%", position: "absolute", top: 60, bottom: 120 }),
        overflowY: "scroll",
      }}
    >
      <Typography.FileFieldDetail
        sx={{
          fontFamily: "Noto Sans JP !important",
          my: "12px",
          ml: "20px",
          ":hover": { opacity: 0.8, cursor: "pointer" },
        }}
        onClick={() => closeDetail()}
      >
        {"＜　"}
        {t("page_back")}
      </Typography.FileFieldDetail>
      {isTablet ? (
        <Grid container sx={{ mt: "0px", height: "32px", borderBottom: "1px dotted #D4D3D7" }}>
          {headers.map((header, index) => (
            <TableHeaderItem
              key={index}
              name={header.name}
              size={header.size}
              sortby={header.sortby}
            />
          ))}
        </Grid>
      ) : (
        <></>
      )}
      <UserTableItem item={item} handleSelected={() => {}} />
      <Box sx={{ py: "20px" }}>
        <MemberTab selected={selectedTab} tabs={tabs} handleTab={setSelectedTab} />
        {userType === MEMBER_TYPE.USER && selectedTab === TAB.REGISTERED_INFORMATION && (
          <UserDetail item={item} />
        )}
        {userType === MEMBER_TYPE.USER && selectedTab === TAB.GENERAL_MEMO && (
          <MemoList userID={item.userId as string} />
        )}
        {userType === MEMBER_TYPE.ADVISER && selectedTab === TAB.REGISTERED_INFORMATION && (
          <AdviserDetail item={item} />
        )}
        {userType === MEMBER_TYPE.ADVISER && selectedTab === TAB.GENERAL_MEMO && (
          <MemoList userID={item.userId as string} />
        )}
        {userType === MEMBER_TYPE.COMPANY && selectedTab === TAB.REGISTERED_INFORMATION && (
          <CompanyDetail item={item} />
        )}
        {userType === MEMBER_TYPE.COMPANY && selectedTab === TAB.JOB_INFORMATION && (
          <JobDetail item={item} />
        )}
        {userType === MEMBER_TYPE.COMPANY && selectedTab === TAB.COMPANY_INFORMATION && (
          <ServiceDetail item={item} />
        )}
        {userType === MEMBER_TYPE.COMPANY && selectedTab === TAB.COMPANY_MEMO && (
          <MemoList userID={item.userId as string} />
        )}
        {userType === MEMBER_TYPE.ADMINISTRATOR && selectedTab === TAB.REGISTERED_INFORMATION && (
          <AdministratorDetail item={item} />
        )}
        {userType === MEMBER_TYPE.ADMINISTRATOR && selectedTab === TAB.GENERAL_MEMO && (
          <MemoList userID={item.userId as string} />
        )}
      </Box>
    </Box>
  )
}
